import { render, staticRenderFns } from "./StudentClassDataManage.vue?vue&type=template&id=5992cac6&scoped=true"
import script from "./StudentClassDataManage.vue?vue&type=script&lang=js"
export * from "./StudentClassDataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992cac6",
  null
  
)

export default component.exports